export default "__VITE_ASSET__09582b5e__"